<template>
  <v-container>
    <ClinicStaff v-if="clinicId" :clinic-id="clinicId" />
    <v-alert v-else type="warning" outlined> No clinic selected </v-alert>
  </v-container>
</template>

<script>
import ClinicStaff from '@/components/ClinicProfile/ClinicStaff';
import { mapGetters } from 'vuex';

export default {
  name: 'Staff',
  components: {
    ClinicStaff,
  },
  computed: {
    ...mapGetters('auth', ['clinicId', 'isClinicStaff']),
  },
};
</script>
